<template lang='pug'>
  v-card
    v-card-text.pt-4
      v-text-field(v-model="editName"
                  color='accent'
                  filled
                  single-line
                  :rules="characterInputRules.name"
                  :label="dataBrowserResource.name"
                  :disabled="disableNameInput"
                  @blur="onNameChange")
      div.d-flex.flex-row.align-center.mb-4
        p.ma-0.mr-4 {{dataBrowserResource.share}}
        v-switch(v-model="editSharing"
                color='accent'
                :disabled="disableSharing"
                @change="onShareChange")
      v-textarea(v-model="editNotes"
                color='accent'
                filled
                rows="2"
                no-resize
                :rules="characterInputRules.notes"
                :label="dataBrowserResource.notes"
                :disabled="disableNotesInput"
                @blur="onNotesChange")
    v-card-actions
      v-spacer
      v-btn(outlined
            color='accent'
            @click.native='onAction(-1)') {{commonResource.close}}
</template>

<script>
import commonResource from '@/resources/common'
import dataBrowserResource from '@/resources/dataBrowser'
import { characterDataRules } from '@/resources/inputRules'
import ShareLevel from '@/constants/Day6ShareLevel'

export default {
  name: 'LoadEditCharacterData',
  props: {
    editingData: {
      type: Object,
      default: () => ({})
    },
    disableNameInput: Boolean,
    disableSharing: Boolean,
    disableNotesInput: Boolean
  },
  data: function () {
    return {
      commonResource,
      dataBrowserResource,
      characterInputRules: characterDataRules,
      editName: '',
      editNotes: '',
      editSharing: false
    }
  },
  methods: {
    setEditing ({ name, notes, shareLevel }) {
      this.editName = name || ''
      this.editNotes = notes || ''
      this.editSharing = shareLevel === ShareLevel.PUBLIC
    },
    onAction (action) {
      this.$emit('editor-action', { action })
    },
    onNameChange () {
      this.$emit('name-change', { name: this.editName })
    },
    onShareChange (isOn) {
      this.$emit('share-change', { isSharing: isOn })
    },
    onNotesChange () {
      this.$emit('notes-change', { notes: this.editNotes })
    }
  }
}
</script>
